import { works } from '@/mocks/works';
import WorkCard from '@/components/feature/WorkCard';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function FeaturedSection() {
  const featured = works.slice(6, 12);

  return (
    <section className="w-full border-t border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="编辑精选"
            title="参赛作品精选"
            description="从本期通过复核的作品里挑出六篇，覆盖盘点、现场、花絮与行业观察等不同写法。"
            action={{ to: '/works', label: '进入作品合集' }}
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((work, index) => (
            <Reveal key={work.id} delay={index * 70}>
              <WorkCard work={work} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}